import { Base } from "./base";
import { Customer, CustomerDTO } from "./customer";
import { Zones, ZonesDTO } from "./zone";
import { UntypedFormGroup } from "@angular/forms";

export interface AddressDTO {
  id?: number;
  latitude?: number;
  longitude?: number;
  street?: string;
  house_number?: string;
  door_bell?: string;
  city?: string;
  zipcode?: string;
  apartment_number?: string;
  type?: string;
  zone_id?: number;
  zone?: ZonesDTO;
  customer_id?: number;
  customer?: CustomerDTO;
}

export class Address extends Base {
  street: string;
  latitude: number;
  longitude: number;
  houseNumber: string;
  doorBell: string;
  city: string;
  zipcode: string;
  aptNumber: string;
  type: string;
  zone: Zones;
  customer: Customer;

  constructor(source) {
    super(source);
    if (source) {
      this.street = source.street;
      this.latitude = Number(source.latitude);
      this.longitude = Number(source.longitude);
      this.houseNumber = source.house_number;
      this.doorBell = source.door_bell;
      this.city = source.city;
      this.zipcode = source.zipcode;
      this.aptNumber = source.apartment_number;
      this.type = source.type;
      if (source.zone) {
        this.zone = new Zones(source.zone);
      }
      this.customer = source.customer ? new Customer(source.customer) : null;
    }
  }

  toDTO(excludes?: string[]): AddressDTO {
    let dto: AddressDTO = {
      id: this.id,
      street: this.street,
      latitude: this.latitude,
      longitude: this.longitude,
      house_number: this.houseNumber,
      door_bell: this.doorBell,
      city: this.city,
      zipcode: this.zipcode,
      apartment_number: this.aptNumber,
      type: this.type
    };
    if (this.zone && !this.isToBeExcluded("zone", excludes)) {
      dto.zone_id = this.zone.id;
      dto.zone = this.zone.toDTO();
    }
    if (this.customer && !this.isToBeExcluded("customer", excludes)) {
      dto.customer_id = this.customer.id;
      dto.customer = this.customer.toDTO(["addresses"]);
    }
    return dto;
  }

  static fromFormGroup(formGroup: UntypedFormGroup): Address {
    const formModel = formGroup.value;
    let address: Address;

    if (formModel.address?.latitude) {
      address = formModel.address;
      address.doorBell = formModel.doorBell;
      address.zone = formModel.zone;
    } else {
      address = new Address(null);
      address.houseNumber = formModel.houseNumber;
      address.doorBell = formModel.doorBell;
      address.street = formModel.street;
      address.city = formModel.city;
      address.zipcode = formModel.zipcode;
      address.zone = formModel.zone;
    }

    return address;
  }

  public static fromGoogleAddress(googleData): Address {

    let result: Address = new Address(null);

    result.street = googleData.address_components.find(c => c.types[0] === "route") ? googleData.address_components.find(c => c.types[0] === "route").long_name : null;

    result.houseNumber = googleData.address_components.find(c => c.types[0] === "street_number") ? googleData.address_components.find(c => c.types[0] === "street_number").long_name : null;

    // TODO - mrosetti - Da gestire se si abilita google result.formattedAddress = googleData.formatted_address;

    if (googleData.types[0] == "street_address") {
      if (googleData.vicinity) {
        result.city = googleData.vicinity;
      } else {
        if (googleData.address_components.find(c => c.types[0] === "administrative_area_level_3")) {
          result.city = googleData.address_components.find(c => c.types[0] === "administrative_area_level_3").long_name;
        }
      }
    } else {
      if (googleData.address_components.find(c => c.types[0] === "administrative_area_level_3")) {
        result.city = googleData.address_components.find(c => c.types[0] === "administrative_area_level_3").long_name;
      } else {
        result.city = googleData.address_components.find(c => c.types[0] === "locality").long_name;
      }
    }


    result.zipcode = googleData.address_components.find(c => c.types[0] === "postal_code") ? googleData.address_components.find(c => c.types[0] === "postal_code").long_name : null;

    result.latitude = googleData.geometry.location.lat();
    result.longitude = googleData.geometry.location.lng();

    return result;
  }

  public get formattedAddress(): string {
    if (this.houseNumber && this.city) {
      return `${this.street}, numero civico: ${this.houseNumber}, città: ${this.city}, codice postale: ${this.zipcode}`;
    } else {
      return `${this.street}`;
    }
  }

}
